module.exports = __webpack_public_path__ + "static/media/pamain.00823038.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain.eot
// module id = ./src/assets/fonts/pamain.eot
// module chunks = 0